import React from 'react';
import {Flex, Text, Link, Button} from '@priority-software/priority-style-react';
import {texts} from '../Announcement/data/texts';
import {MessageDetails} from './types';
import styles from './UpgradeDialog.module.scss';
import {getUpgradeDateString, getTestEnvUrl, getReleaseNotesUrl} from './texts/utils';
import {isRTL} from '../../Localization';

interface FirstSlideProps {
    details: MessageDetails;
    onNext: () => void;
}

export const FirstSlide: React.FC<FirstSlideProps> = ({details, onNext}) => {
    const cloudServiceEmail = 'cloudservices@priority-software.com';
    const upgradeDetails = getUpgradeDateString(details);
    const testEnvUrl = getTestEnvUrl();
    const releaseNotesUrl = getReleaseNotesUrl();

    const onOpenLink = (url: string) => {
        return window.open(url, '_blank');
    };

    const onMailTo = () => {
        return window.open(`mailto:${cloudServiceEmail}`, '_blank');
    };

    return (
        <Flex direction="column">
            <Text skin="paragraph-2" textColor="primary-700">
                <Text skin="paragraph-2" componentClasses={styles.paragraphGap}>
                    {upgradeDetails}
                </Text>
                <Text skin="paragraph-2" fontWeight="bold">
                    {texts.prepareTitle}
                </Text>
                <Text skin="paragraph-2" componentClasses={styles.paragraphGap}>
                    <ul className={styles.listWrapper}>
                        <li>
                            {texts.firstBullet}{' '}
                            <Link onClick={() => onOpenLink(testEnvUrl)}>{testEnvUrl}</Link>
                        </li>
                        <li>
                            {texts.secondBulletP1}{' '}
                            <Link onClick={() => onOpenLink(releaseNotesUrl)}>
                                {texts.releaseNotes}
                            </Link>
                            {isRTL() ? '. ' : ' '}
                            {texts.secondBulletP2}
                        </li>
                    </ul>
                </Text>
                <Text skin="paragraph-2">
                    {texts.finalNote} <Link onClick={onMailTo}>{cloudServiceEmail}</Link>
                </Text>
            </Text>

            <Flex componentClasses={styles.footer} justifyContent="flex-end">
                <Button wideButton onClick={onNext} size={'medium'}>
                    {texts.next}
                </Button>
            </Flex>
        </Flex>
    );
};
